import React from 'react';
import { Phone, MessageCircle, FileText } from 'lucide-react';

const MobileStickyBar = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/919351292512?text=Hi, I want to know about mineral water plant setup', '_blank');
  };

  const handleCall = () => {
    window.location.href = 'tel:+919351292512';
  };

  const handleGetReport = () => {
    // Scroll to quote form
    const form = document.getElementById('quote-form');
    if (form) {
      form.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact';
    }
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 lg:hidden">
      <div className="bg-white border-t-2 border-gray-200 shadow-2xl">
        <div className="grid grid-cols-3 gap-0">
          {/* WhatsApp */}
          <button
            onClick={handleWhatsApp}
            className="flex flex-col items-center justify-center py-3 bg-green-600 text-white hover:bg-green-700 active:bg-green-800 transition-colors"
          >
            <MessageCircle className="w-5 h-5 mb-1" />
            <span className="text-xs font-semibold">WhatsApp</span>
          </button>

          {/* Call Now */}
          <button
            onClick={handleCall}
            className="flex flex-col items-center justify-center py-3 bg-blue-600 text-white hover:bg-blue-700 active:bg-blue-800 transition-colors border-x border-white"
          >
            <Phone className="w-5 h-5 mb-1" />
            <span className="text-xs font-semibold">Call Now</span>
          </button>

          {/* Get Report */}
          <button
            onClick={handleGetReport}
            className="flex flex-col items-center justify-center py-3 bg-orange-600 text-white hover:bg-orange-700 active:bg-orange-800 transition-colors"
          >
            <FileText className="w-5 h-5 mb-1" />
            <span className="text-xs font-semibold">Get Report</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default MobileStickyBar;